module.exports = __webpack_public_path__ + "img/9788957985113.0ab9da51.jpg";